import map from 'lodash/map'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { useBlogCategoryList } from '../BlogCategory/useBlogCategoryList'
import { blogStatuses } from '../BlogStatusOptions'
const blogListFieldConfig: ListFieldConfig = {
  title: {
    name: 'title',
    displayName: 'Title',
    defaultOnSearch: true,
    size: 350,
    index: 0,
  },
  slug: {
    name: 'slug',
    displayName: 'Slug',
    size: 220,
    index: 1,
  },
  summary: {
    name: 'summary',
    displayName: 'Summary',
    size: 620,
    index: 2,
  },
  tags: {
    name: 'tags',
    displayName: 'Tags',
    type: ListFieldTypeEnum.array,
    excludeOnSearch: true,
    size: 350,
    index: 3,
  },
  updatedAt: {
    name: 'updatedAt',
    displayName: 'Updated',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 180,
    index: 4,
  },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: blogStatuses,
    },
    size: 120,
    index: 5,
  },
  _id: {
    name: '_id',
    isVisible: false,
  },
}

/** The Blog list's columns; Category filters on the category id and picks from the tenant's real categories. */
export const useBlogListFieldConfig = (): ListFieldConfig => {
  const { list } = useBlogCategoryList()

  return {
    ...blogListFieldConfig,
    category: {
      name: 'category._id',
      displayName: 'Category',
      type: ListFieldTypeEnum.select,
      fieldSettings: { listValues: map(list, ({ _id, name }) => ({ value: _id, title: name })) },
      excludeOnSearch: true,
      excludeOnSort: true,
      size: 180,
      index: 6,
    },
  }
}
